<template>
  <van-popup v-model:show="data.show" round>
    <div class="container">
      <img class="icon_a" :src="props.type === 'fb' ? fb: addToHome" alt="">
      <img class="icon_c" src="~/assets/images/reader/icon-reader-popup-close.png" alt="" @click="closePopup">
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import {reactive, defineProps} from 'vue'
import fb from '~/assets/images/other/icon-other-add-to-fb.png'
import addToHome from '~/assets/images/other/icon-other-add-to-home.png'

const props = defineProps({
  type: {
    type: String,
    default: 'fb'
  }
})
const data = reactive({
  show: false
})

const closePopup = () => {
  data.show = !data.show
}

defineExpose({
  closePopup
})
</script>

<style scoped lang="scss">
.van-popup {
  background: transparent;

}

.container {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

    .icon_a {
      width: 100%;
    }

    .icon_c {
      width: 25px;
      height: 25px;
      margin-top: 21px;
    }
}

</style>
